@if (formattedDescription) {
  <div [class.multi-line]="isMultiLine">
    @switch (type) {
      @case ('PoolSale') {
        Sold from
        <a
          data-dd-action-name="transaction-description-cell-renderer.pool-link.sold"
          [routerLink]="poolRoute(data)"
          >{{ data.poolName }}</a
        >
        for {{ data.price | aacurrency }}
        @if (hasTaxableUse) {
          ({{ data.taxableUse | aapercent }} Taxable Use)
        }
      }

      @case ('PoolWriteOff') {
        Disposed from
        <a
          data-dd-action-name="transaction-description-cell-renderer.pool-link.disposed"
          [routerLink]="poolRoute(data)"
          >{{ data.poolName }}</a
        >
      }

      @case ('AddToPool') {
        Added to
        <a
          data-dd-action-name="transaction-description-cell-renderer.pool-link.added"
          [routerLink]="poolRoute(data)"
          >{{ data.poolName }}</a
        >
        @if (hasTaxableUse) {
          ({{ data.transferredValue || 0 | aacurrency }} -
          {{ data.taxableUse | aapercent }}
          Taxable Use)
        }
      }

      @case ('TransferToPool') {
        Transferred to
        <a
          data-dd-action-name="transaction-description-cell-renderer.pool-link.transferred"
          [routerLink]="poolRoute(data)"
          >{{ data.poolName }}</a
        >
        @if (hasTaxableUse) {
          ({{ data.transferredValue || 0 | aacurrency }} -
          {{ data.taxableUse | aapercent }}
          Taxable Use)
        }
      }

      @default {
        <div [innerHTML]="formattedDescription | keepHtml"></div>
      }
    }
  </div>
}

@if (sourceText || importName) {
  <div class="source" [class.multi-line]="isMultiLine">
    {{ sourceText }}
    @if (importName) {
      <a
        data-dd-action-name="transaction-description-cell-renderer.import-link"
        [href]="sourceLink"
        >{{ importName }}</a
      >
    }
  </div>
}
